const dtoYearValuesToTable = (v) => ({
  [`plan${v.year}`]: v.plan === null ? undefined : v.plan,
  [`planInner${v.year}`]: v.planInner === null ? undefined : v.planInner,
  [`estimate${v.year}`]: v.estimate === null ? undefined : v.estimate,
  [`fact${v.year}`]: v.fact === null ? undefined : v.fact,
  [`factHalf_${v.year}`]: v.factHalf === null ? undefined : v.factHalf,
  [`fact02_${v.year}`]: v.fact02 === null ? undefined : v.fact02,
  [`fact03_${v.year}`]: v.fact03 === null ? undefined : v.fact03,
  [`fact04_${v.year}`]: v.fact04 === null ? undefined : v.fact04,
  [`fact05_${v.year}`]: v.fact05 === null ? undefined : v.fact05,
  [`fact06_${v.year}`]: v.fact06 === null ? undefined : v.fact06,
  [`fact07_${v.year}`]: v.fact07 === null ? undefined : v.fact07,
  [`fact08_${v.year}`]: v.fact08 === null ? undefined : v.fact08,
  [`fact09_${v.year}`]: v.fact09 === null ? undefined : v.fact09,
  [`fact10_${v.year}`]: v.fact10 === null ? undefined : v.fact10,
  [`fact11_${v.year}`]: v.fact11 === null ? undefined : v.fact11,
  [`fact12_${v.year}`]: v.fact12 === null ? undefined : v.fact12,
  [`factSemi_${v.year}`]: v.factSemi === null ? undefined : v.factSemi,
  [`comment${v.year}`]: v.comment === null ? undefined : v.comment,
});

const dtoUsersToPersonsInCharge = (r) => {
  if (!r.users || !r.users.length) return undefined;
  return r.users.reduce((acc, u) => [...acc, `${u.lastName} ${u.firstName} ${u.middleName ? u.middleName : ''}`], []).join(', ');
};

const dtoYearSettings = (r) => (r.settings ? r.settings.reduce((acc, s) => ({ ...acc, [`reportBosses${s.year}`]: s.reportBosses }), {}) : {});

const dtoRowToTable = (r) => {
  const yearsAcc = r.values.reduce((acc, v) => ({ ...acc, ...dtoYearValuesToTable(v), personsInCharge: dtoUsersToPersonsInCharge(r) }), {});
  return { ...r, ...yearsAcc, ...dtoYearSettings(r) };
};

const dtoRowToTableWithComplete = (r) => {
  const yearsAcc = r.values.reduce((acc, v) => {
    let complete;
    if (!r.parentId) {
      if ((v.fact || v.fact === 0) && (v.plan || v.plan === 0)) { complete = v.fact / v.plan * 100; } else { complete = null; }
    }

    return {
      ...acc,
      ...dtoYearValuesToTable(v),
      [`complete${v.year}`]: complete,
    };
  }, {});
  return { ...r, ...yearsAcc, ...dtoYearSettings(r) };
};

const nullifyEmptyValue = (v) => (v === null || typeof v === 'undefined' || v === ''
  ? null
  : v);

const tableYearValuesToDto = (row, year) => ({
  year,
  plan: nullifyEmptyValue(row[`plan${year}`]),
  estimate: nullifyEmptyValue(row[`estimate${year}`]),
  fact: nullifyEmptyValue(row[`fact${year}`]),
  factHalf: nullifyEmptyValue(row[`factHalf_${year}`]),
  fact02: nullifyEmptyValue(row[`fact02_${year}`]),
  fact03: nullifyEmptyValue(row[`fact03_${year}`]),
  fact04: nullifyEmptyValue(row[`fact04_${year}`]),
  fact05: nullifyEmptyValue(row[`fact05_${year}`]),
  fact06: nullifyEmptyValue(row[`fact06_${year}`]),
  fact07: nullifyEmptyValue(row[`fact07_${year}`]),
  fact08: nullifyEmptyValue(row[`fact08_${year}`]),
  fact09: nullifyEmptyValue(row[`fact09_${year}`]),
  fact10: nullifyEmptyValue(row[`fact10_${year}`]),
  fact11: nullifyEmptyValue(row[`fact11_${year}`]),
  fact12: nullifyEmptyValue(row[`fact12_${year}`]),
  factSemi: nullifyEmptyValue(row[`factSemi_${year}`]),
  comment: nullifyEmptyValue(row[`comment${year}`]),
});

const tableRowToDto = (row, years) => ({
  kpiId: row.id,
  values: years.reduce((acc, year) => [...acc, tableYearValuesToDto(row, year)], []),
});

export {
  dtoYearValuesToTable,
  dtoRowToTable,
  dtoRowToTableWithComplete,
  tableYearValuesToDto,
  tableRowToDto,
};
